import React, { useState, useEffect, useContext } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { PostsContext } from '../../contexts/PostsContext';
import FixedHorizontalScrollBox from '../../Components/FixedHorizontalScrollBox';
import { useAuth } from '../../contexts/AuthContext';
import SearchBar from '../../Components/SearchBar';
import { collection, addDoc, doc, getDoc,} from 'firebase/firestore';
import { auth, db } from '../../Firebase/firebase';

const UserProfiles = () => {
  const { categoriesData, loading } = useContext(PostsContext) || {}; // Accessing categoriesData and loading state
  const { currentUser } = useAuth();

  const [userPosts, setUserPosts] = useState({});
  // const [recoveredUsername, setRecoveredUsername] =useState("")

  // const getMissingUsername = async () =>{
  //   if (!username) {
  //     try {
  //       // Fetch username from userData using userId
        
  //       const userDoc = await getDoc(doc(db, "users", post.userId));
  //       if (userDoc.exists()) {
  //         const userData = userDoc.data();
  //         // missingUsername = userData.username
  //         // console.log(missingUsername)
  //         return userData.username
  //         // path = `/${userData.username}`; // Use the fetched username
  //       }
  //     } catch (error) {
  //       console.error("Error fetching username:", error);
  //       return;
  //     }
  //   }
    
  // }

  // useEffect(() => {
  //   const fetchUsername = async () => {
  //     const foundUsername = await getMissingUsername(); // Wait for async function to complete
  //     setRecoveredUsername(foundUsername); // Update state with retrieved username
  //   };
  //   fetchUsername();
  // }, [post.userId]); // Ensure `id` is available when useEffect runs

  useEffect(() => {
    if (!loading) {
      // Flatten the categoriesData to get all posts in a single array
      const allPosts = Object.values(categoriesData).flat();

      // Group posts by userId
      const groupedByUser = allPosts.reduce((acc, post) => {
        const { userId, username, userPhotoURL } = post;

        if (!acc[userId]) {
          //   acc[userId] = [];
          acc[userId] = {
            username: username, // Store the username for this userId
            userPhotoURL: userPhotoURL,
            posts: [],
          };
        }
        // acc[userId].push(post);
        acc[userId].posts.push(post);
        return acc;
      }, {});

      setUserPosts(groupedByUser);
    }
  }, [categoriesData, loading]);

  if (loading) {
    return <CircularProgress />; // Show loading indicator while data is being fetched
  }

  return (
    <Box
      sx={{
        height: '100vh', // Full viewport height
        overflowY: 'auto', // Enable vertical scrolling
        mb: 0,
      }}
    >
      <Box
        sx={{
          display: { xs: 'flex', sm: 'flex', lg: 'none', xl: 'none' },
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          pb: 0.5,
          height: 45,
          ml: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
          position: 'sticky',
          top: 0,
          zIndex: 1000, // Ensure it's above other content while scrolling
        }}
      >
        <SearchBar width={300} />
      </Box>
      {/* The component maps over the keys of the userPosts object (i.e., the userIds) */}
      {Object.keys(userPosts).map((userId) =>
        userPosts[userId].posts.length > 0 ? (
          <FixedHorizontalScrollBox
            key={userId}
            data={userPosts[userId].posts}
            height='40vh'
            userId={userId}
            postID={userPosts[userId].posts.id}
            // username={userPosts[userId].username ||"Anonymous"} // Pass the username prop
            username={userPosts[userId].username} // Pass the username prop
            userPhotoURL={
              userPosts[userId].userPhotoURL ||
              '../images/siteImages/defaultAvatar.jpg'
            }
            userBannerImage={
              userPosts[userId].bannerImage ||
              '../images/siteImages/dashboardDesign.png'
            }
            isUserProfilePage={true}
            userPostsLength={userPosts[userId].posts.length}
            //category={userPosts[userId].posts[0].category}
            // path={`/user/${userId}`} //where the more arrow click will take you
          />
        ) : null
      )}
    </Box>
  );
};

export default UserProfiles;
